import { PropsWithChildren } from 'react';

import { cx } from 'libs/ui/theme';
// eslint-disable-next-line no-restricted-imports
import { NavLink } from 'react-router-dom';
import { PropsWithTestAttribute } from 'types/testAttribute';

import { NavigationLinkClasses } from './types';

interface Props extends PropsWithTestAttribute {
  to: string;
  className?: string;
}

export const NavigationLink = ({
  children,
  className,
  to,
  datax,
}: Props & PropsWithChildren) => (
  <NavLink
    className={({ isActive }) =>
      cx(isActive && NavigationLinkClasses.activeLink, className)
    }
    datax={datax}
    to={to}
  >
    {children}
  </NavLink>
);
